import Vue from 'vue'
import Router from 'vue-router'
import Static from '@/components/Static'
import News from '@/components/News'
import Projects from '@/components/Projects'
import Project from '@/components/Project'
import Subscription from '@/components/Subscription'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/access/:id?/:stub?',
      name: 'access'
    },
    {
      path: '/:route(projekte)/:filter?',
      name: 'projekte',
      components: {
        'overlay': Projects
      },
      children: [
        {
          path: '/:route(projekte)/:id/:stub',
          name: 'projekt',
          component: Project
        }
      ]
    },
    {
      path: '/:route(news)/:id?/:stub?',
      name: 'news',
      components: {
        'overlay': News
      }
    },
    {
      path: '/:route(anmeldung)',
      name: 'subscription',
      components: {
        'overlay': Subscription
      }
    },
    {
      path: '/:route/:id?/:stub?',
      name: 'overlay',
      components: {
        'overlay': Static
      }
    },
    {
      path: '/',
      name: 'home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js